import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import MissionTabs from '../Missions/components/MissionTabs';
import useBattles from 'shared/screens/Battles/hooks/useBattles';
import BattlesHelp from './components/BattlesHelp';
import BattlesBegin from './components/BattlesBegin';
import BattlesRoom from './components/BattlesRoom';
import BattlesEmpty from './components/BattlesEmpty';

const Battles = ({ navigation }) => {
  const battlesData = useBattles({ navigation });
  const [backgroundImageLoaded, setBackgroundImageLoaded] = useState(false);
  const { battlesAssets, noAvailableGames } = battlesData;
  const BattleSplashBackground = battlesAssets?.BATTLES_BACKGROUND_SPLASH;
  useEffect(() => {
    if (!BattleSplashBackground) {
      setBackgroundImageLoaded(true);
      return;
    }
    const img = new Image();
    img.src = BattleSplashBackground;
    img.decode().finally(() => setBackgroundImageLoaded(true));
  }, [BattleSplashBackground]);

  return (
    <Container>
      <BattlesHelp battlesAssets={battlesAssets} />
      {backgroundImageLoaded && <MissionTabs navigation={navigation} {...battlesData} isOnBattles={true} />}
      {noAvailableGames ? (
        <BattlesEmpty battlesAssets={battlesAssets} />
      ) : (
        <>
          <BattlesBegin {...battlesData} />
          <BattlesRoom {...battlesData} />
        </>
      )}
    </Container>
  );
};

export default Battles;

const Container = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  overflow: hidden;
`;

